import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faAngleUp } from '@fortawesome/pro-light-svg-icons';

export type ProLightAngleUpProps = IconComponentProps;

export const ProLightAngleUp = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightAngleUpProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faAngleUp}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faAngleUp}
    />
  );
};

ProLightAngleUp.displayName = 'ProLightAngleUp';
